import React from 'react';
import { useEpicIssueTypeName } from '@atlassian/jira-backlog-epics-store/src/selectors/index.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import { srcLight as EmptyStateGrowthSprout } from '@atlassian/jira-illustrations/src/ui/adg4/jira/spots/empty/components/empty-state-growth-sprout/index.tsx';
import Illustration from '@atlassian/jira-illustrations/src/ui/adg4/jira/spots/basics/components/toolbox/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { DEFAULT_PARENT_ISSUE_TYPE_NAME } from '../../../../../common/constants.tsx';
import EmptyState from '../../../../../common/ui/panel/empty-state/index.tsx';
import GrowthSprout from './assets/growth-sprout.svg';
import messages from './messages.tsx';

export const EpicEmptyState = () => {
	const { formatMessage } = useIntl();

	const [epicIssueTypeName] = useEpicIssueTypeName();

	const issueTypeName =
		epicIssueTypeName && epicIssueTypeName !== DEFAULT_PARENT_ISSUE_TYPE_NAME
			? epicIssueTypeName
			: DEFAULT_PARENT_ISSUE_TYPE_NAME.toLowerCase();
	return (
		<EmptyState
			{...(fg('jsw-backlog-panel-asset-consolidation')
				? { image: { src: EmptyStateGrowthSprout } }
				: { image: { src: GrowthSprout } })}
			Illustration={Illustration}
			messages={[
				formatMessage(messages.information),
				formatMessage(
					expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
						? messages.suggestionIssueTermRefresh
						: messages.suggestion,
					{
						epicIssueTypeName: issueTypeName,
					},
				),
			]}
		/>
	);
};
